import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { usePaidRestBoard } from '../../../hooks/usePaidRestBoard';
import { VacationPaidRestTable } from '../../../components/VacationPaidRestTable';
import { VacationPaidRestHistoryModal } from '../../../components/VacationPaidRestHistoryModal';
import { VacationPaidRestFilterSidebar } from '../../../components/VacationPaidRestFilterSidebar';

const SEARCH_PLACEHOLDER = 'Buscar por nome, CNPJ ou empresa';
const SEARCH_LABEL = 'Buscar PJ';

export function PaidRestTab() {
    const {
        rows,
        searchQuery,
        setSearchQuery,
        isLoading,
        selectedSituations,
        toggleSituation,
        selectedRights,
        toggleRight,
        selectedRow,
        setSelectedRow,
        counts,
    } = usePaidRestBoard();

    return (
        <div className="flex flex-col gap-4 lg:flex-row lg:items-start">
            <VacationPaidRestFilterSidebar
                counts={counts}
                selectedSituations={selectedSituations}
                onToggleSituation={toggleSituation}
                selectedRights={selectedRights}
                onToggleRight={toggleRight}
                isLoading={isLoading}
                className="lg:order-last"
                tourId="paidrest-filters"
            />

            <div className="min-w-0 flex-1 space-y-4">
                <div className="relative sm:max-w-xs sm:flex-1" data-tour="paidrest-search">
                    <MagnifyingGlassIcon
                        className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-raro-gray-400"
                        aria-hidden="true"
                    />
                    <input
                        type="search"
                        aria-label={SEARCH_LABEL}
                        placeholder={SEARCH_PLACEHOLDER}
                        value={searchQuery}
                        onChange={(event) => setSearchQuery(event.target.value)}
                        className="w-full rounded-xl border border-raro-gray-200 py-2 pl-9 pr-3 text-sm text-raro-gray-900 placeholder:text-raro-gray-400 focus:border-primary-500 focus:ring-primary-500 font-montserrat"
                    />
                </div>

                <div data-tour="paidrest-table">
                    <VacationPaidRestTable
                        rows={rows}
                        isLoading={isLoading}
                        selectedRow={selectedRow}
                        onRowSelect={setSelectedRow}
                    />
                </div>

                <VacationPaidRestHistoryModal
                    row={selectedRow}
                    isOpen={Boolean(selectedRow)}
                    onClose={() => setSelectedRow(null)}
                />
            </div>
        </div>
    );
}
